import { gradeBandLabel } from '../utils/gradeLabels.js';
export const TRANSLATIONS = {
  en: {
    app_title: "Stepping Stones",
    nav_dashboard: "Home",
    nav_classes: "Classes",
    nav_practice: "Extra practice",
    nav_collapse: "Collapse sidebar",
    nav_expand: "Expand sidebar",
    nav_close: "Close menu",
    practice_back: "Back to Extra practice",
    practice_intro: "Choose a subject to practise at your own pace.",
    practice_class_note: "Looking for work from your teacher? Open Classes to find your lessons and assigned practice.",
    practice_daily_done: "Daily done",
    home_main_title: "Start here",
    home_classes_desc: "Join your class and review assignments.",
    nav_vocab: "Vocabulary",
    nav_grammar: "Grammar",
    nav_writing: "Writing",
    nav_speaking: "Speaking",
    nav_test: "Test",
    nav_reading: "Reading",
    nav_leaderboard: "Leaderboard",
    nav_shop: "Shop",
    nav_admin: "Admin Panel",
    grade_1_2: gradeBandLabel(1, 'en'),
    grade_3_4: gradeBandLabel(2, 'en'),
    grade_5_6: gradeBandLabel(3, 'en'),
    tab_login: "Log In",
    tab_signup: "Sign Up",
    login_title: "Welcome Back",
    signup_title: "Create Account",
    auth_invalid_name: "Please use a name between 2 and 40 characters.",
    auth_short_password: "New passwords must be at least 8 characters.",
    auth_unavailable: "Sign-in and signup are temporarily unavailable. Please contact your teacher or site administrator.",
    auth_connection_error: "We could not finish your request. Please try again. If you already signed up, try Log In with the same details.",
    auth_logging_in: "Signing in…",
    auth_creating: "Creating account…",
    auth_guest: "Continue as Guest Student",
    login_name: "Your Name",
    login_pass: "Password",
    btn_login: "Log In",
    btn_signup: "Sign Up",
    btn_logout: "Log Out",
    guest: "Guest Student",
    stars_earned: "Stars Earned",
    module_vocab_desc: "Learn and test new words.",
    module_grammar_desc: "Master rules and sentence structure.",
    module_writing_desc: "Write stories and get AI feedback.",
    module_speaking_desc: "Practice reading out loud.",
    module_reading_desc: "Read passages and answer questions.",
    home_explore_title: "Explore More",
    home_leaderboard_desc: "See this week's top learners.",
    home_shop_desc: "Use your stars in the shop.",
    home_test_desc: "Find a suitable practice grade band.",
    btn_start: "Start",
    btn_next: "Next",
    btn_submit: "Submit",
    btn_retry: "Try Again",
    btn_continue: "Continue",
    feedback_ai: "AI Feedback",
    loading: "Processing...",
    score_title: "Activity Complete!",
    leaderboard_title: "Top Scholars",
    profile_title: "My Profile",
    stat_vocab: "Words Learned",
    stat_grammar: "Grammar Questions Completed",
    stat_writing: "Writings Completed",
    stat_speaking: "Speaking Practices",
    stat_reading: "Readings Completed",
    menu_learn: "Learning Mode",
    menu_test: "Testing Mode",
    rank_current: "Your Rank",
    choose_mode: "Choose Your Mode",
    mode_learn_desc: "Study and review the material first.",
    mode_test_desc: "Test your knowledge and earn stars!",
    today_mission: "Today's Mission",
    past_practices: "Past Practices Library",
    all_caught_up: "You are all caught up for today!",
    review: "Review",

    // Added Instructions & UI Keys
    tab_learn: "Learn 📚",
    tab_learn_short: "Learn",
    tab_learn_mode: "Learn",
    tab_vocab_list: "Vocab List",
    tab_question_bank: "Question Bank",
    tab_question_bank_short: "Bank",
    tab_voice_battle_mode: "Voice Battle ⚔️",
    tab_courtroom_trial: "Courtroom Trial ⚖️",
    tab_courtroom_trial_short: "Trial",
    full_curriculum: "Full Curriculum",
    completed_today: "Completed Today! ✨",
    btn_start_launch: "Start 🚀",
    btn_browse_all: "Browse All 🚀",
    btn_keep_practicing: "Keep Practicing ✏️",
    all_mastered_title: "All Mastered! ✨",
    all_mastered_desc: "You have successfully mastered every concept for this grade band.",

    // Speaking Module
    daily_speaking_goal: "Daily Speaking Goal",
    daily_speaking_title: "Daily Speaking 🎙️",
    daily_speaking_desc: "Practice your pronunciation and fluency with today's speaking challenge!",
    keep_practicing_speaking_title: "Keep Practicing 🗣️",
    keep_practicing_speaking_desc: "Browse the full list of speaking prompts to retry, review, or master!",

    // Reading Module
    daily_reading_goal: "Daily Reading Goal",
    daily_reading_title: "Daily Reading 📘",
    daily_reading_desc: "Read a new story and answer questions to test your comprehension!",
    keep_practicing_reading_title: "Keep Practicing 📚",
    keep_practicing_reading_desc: "Browse the full list of stories in your grade band to revisit or practice specific ones.",

    // Vocab Module
    daily_vocab_goal: "Daily Vocab Goal",
    daily_vocab_title: "Daily Vocab 📖",
    daily_vocab_desc: "Learn 5 new words today. Practice until you score perfectly!",
    keep_practicing_vocab_title: "Keep Practicing 📚",
    keep_practicing_vocab_desc: "Review 5 random words, then play a random fun minigame!",

    // Grammar Module
    daily_grammar_goal: "Daily Grammar Goal",
    daily_grammar_title: "Daily Grammar 📜",
    daily_grammar_desc: "Learn a new grammar concept today and take a quick quiz!",
    keep_learning_grammar_title: "Keep Learning 📚",
    keep_learning_grammar_desc: "Browse the full list of grammar concepts and choose what to study.",

    // Writing Module
    writing_practice_title: "Writing Practice",
    daily_writing_goal: "Daily Writing Goal",
    daily_mission_title: "Today's Writing Mission",
    daily_mission_desc: "Complete today's writing prompt to earn stars!",
    keep_practicing_title: "Keep Practicing 📚",
    keep_practicing_desc: "Browse the full list of writing prompts in your grade band to practice or improve.",
    start_writing_btn: "Start Writing 🚀",
    keep_practicing_btn: "Keep Practicing 🚀",

    voice_battle_title: "Voice Battle ⚔️",
    choose_hero: "Choose your Hero:",
    choose_pet: "Choose your Pet:",
    select_monster: "Select a monster to battle!",
    click_mic_attack: "Click the mic and speak the target word to attack!",
    
    courtroom_select_level: "Select a Stage",
    courtroom_examine_statement: "Examine the witness statement and judge if there is a grammar error!",
    courtroom_statement_correct: "Statement is Correct",
    courtroom_statement_flawed: "Contains Grammar Error",
    
    shop_title: "Item Shop 🛒",
    shop_subtitle: "Upgrade your Voice Battle heroes and Courtroom trial equipment!",
    tab_voice_battle: "⚔️ Voice Battle",
    tab_grammar_court: "⚖️ Grammar Courtroom",

    shop_bronze_shield_name: "Bronze Aegis Shield 🛡️",
    shop_bronze_shield_desc: "Protects 1 Heart from mistakes in Grammar Courtroom!",
    shop_silver_shield_name: "Silver Guardian Shield 🛡️",
    shop_silver_shield_desc: "Protects 2 Hearts from mistakes in Grammar Courtroom!",
    shop_gold_shield_name: "Golden Verdict Shield 🛡️",
    shop_gold_shield_desc: "Protects all 3 Hearts from mistakes in Grammar Courtroom!",
    shop_gavel_name: "Golden Judge Gavel (2x Stars) ⭐⭐",
    shop_gavel_desc: "Earn double (2x) stars whenever you win a Courtroom trial!",
    
    shop_hourglass_name: "Magic Hourglass ⏳",
    shop_hourglass_desc: "Gives you 90 seconds to speak instead of 60 seconds!",
    shop_knight_name: "Knight Class ⚔️",
    shop_knight_desc: "Deals 30 attack damage every turn in Voice Battle!",
    shop_paladin_name: "Paladin Class ✨",
    shop_paladin_desc: "Deals 50 super attack damage every turn in Voice Battle!",
    shop_golem_name: "Crystal Golem 🗿",
    shop_golem_desc: "Bypasses enemy shields to deal direct damage!",
    shop_dragon_name: "Fire Dragonling 🐉",
    shop_dragon_desc: "Shoots fireballs for 10 extra bonus damage!",
    shop_griffin_name: "Storm Griffin 🦅",
    shop_griffin_desc: "Multiplies your attack damage by 5x!",

    shop_equip_hero: "Equip Hero",
    shop_equip_pet: "Equip Pet",
    shop_equip_shield: "Equip Shield",
    shop_hero_equipped: "Equipped Hero",
    shop_pet_equipped: "Pet Equipped",
    shop_shield_equipped: "Shield Equipped",
    shop_owned_active: "Owned & Active",
    shop_purchase_btn: "Purchase",
    shop_need_stars: "Need"
  },
  zh: {
    app_title: "铺路石 (Stepping Stones)",
    nav_dashboard: "主页",
    nav_classes: "班级",
    nav_practice: "拓展练习",
    nav_collapse: "收起侧边栏",
    nav_expand: "展开侧边栏",
    nav_close: "关闭菜单",
    practice_back: "返回拓展练习",
    practice_intro: "选择一个科目，按自己的节奏练习。",
    practice_class_note: "想找老师布置的任务？请打开“班级”，查看课程和老师布置的练习。",
    practice_daily_done: "今日已完成",
    home_main_title: "从这里开始",
    home_classes_desc: "加入班级，完成和复习作业。",
    nav_vocab: "词汇",
    nav_grammar: "语法",
    nav_writing: "写作",
    nav_speaking: "口语",
    nav_test: "测试",
    nav_reading: "阅读",
    nav_leaderboard: "排行榜",
    nav_shop: "商店",
    nav_admin: "管理面板",
    grade_1_2: gradeBandLabel(1, 'zh'),
    grade_3_4: gradeBandLabel(2, 'zh'),
    grade_5_6: gradeBandLabel(3, 'zh'),
    tab_login: "登录",
    tab_signup: "注册",
    login_title: "欢迎回来",
    signup_title: "创建账号",
    auth_invalid_name: "请使用2至40个字符的用户名。",
    auth_short_password: "新密码至少需要8个字符。",
    auth_unavailable: "暂时无法登录或注册，请联系老师或网站管理员。",
    auth_connection_error: "未能完成请求，请重试。如果已经注册，请用相同的用户名和密码登录。",
    auth_logging_in: "正在登录…",
    auth_creating: "正在创建账号…",
    auth_guest: "以游客学生身份继续",
    login_name: "姓名",
    login_pass: "密码",
    btn_login: "登录",
    btn_signup: "注册",
    btn_logout: "登出",
    guest: "访客学生",
    stars_earned: "获得的星星",
    module_vocab_desc: "学习并测试新单词。",
    module_grammar_desc: "掌握语法规则和句子结构。",
    module_writing_desc: "写故事并获得AI反馈。",
    module_speaking_desc: "练习大声朗读。",
    module_reading_desc: "阅读文章并回答问题。",
    home_explore_title: "更多内容",
    home_leaderboard_desc: "看看本周的优秀学习者。",
    home_shop_desc: "用你的星星兑换物品。",
    home_test_desc: "找到适合自己的练习年级段。",
    btn_start: "开始",
    btn_next: "下一题",
    btn_submit: "提交",
    btn_retry: "再试一次",
    btn_continue: "继续",
    feedback_ai: "AI 反馈",
    loading: "处理中...",
    score_title: "活动完成!",
    leaderboard_title: "优秀学者榜",
    profile_title: "我的个人资料",
    stat_vocab: "学习的单词",
    stat_grammar: "掌握的语法",
    stat_writing: "完成的写作",
    stat_speaking: "口语练习",
    stat_reading: "完成的阅读",
    menu_learn: "学习模式",
    menu_test: "测试模式",
    rank_current: "你的排名",
    choose_mode: "选择你的模式",
    mode_learn_desc: "先学习和复习材料。",
    mode_test_desc: "测试你的知识并获得星星！",
    today_mission: "今日任务",
    past_practices: "历史练习库",
    all_caught_up: "你今天已经完成所有任务了！",
    review: "复习",

    // Added Instructions & UI Keys
    tab_learn: "学习模式 📚",
    tab_learn_short: "学习",
    tab_learn_mode: "学习模式",
    tab_vocab_list: "单词表",
    tab_question_bank: "题库",
    tab_question_bank_short: "题库",
    tab_voice_battle_mode: "语音对决 ⚔️",
    tab_courtroom_trial: "法庭审判 ⚖️",
    tab_courtroom_trial_short: "法庭",
    full_curriculum: "完整课程",
    completed_today: "今日已完成！✨",
    btn_start_launch: "开始 🚀",
    btn_browse_all: "浏览全部 🚀",
    btn_keep_practicing: "继续练习 ✏️",
    all_mastered_title: "全部掌握！✨",
    all_mastered_desc: "你已成功掌握该年级段的所有学习概念。",

    // Speaking Module
    daily_speaking_goal: "每日口语目标",
    daily_speaking_title: "每日口语 🎙️",
    daily_speaking_desc: "通过今天的口语挑战练习发音和流利度！",
    keep_practicing_speaking_title: "继续练习 🗣️",
    keep_practicing_speaking_desc: "浏览所有口语题目列表，重新练习或复习！",

    // Reading Module
    daily_reading_goal: "每日阅读目标",
    daily_reading_title: "每日阅读 📘",
    daily_reading_desc: "阅读一篇新故事并回答问题，检验你的阅读理解能力！",
    keep_practicing_reading_title: "继续练习 📚",
    keep_practicing_reading_desc: "浏览当前年级段的全部故事列表，复习或练习指定故事。",

    // Vocab Module
    daily_vocab_goal: "每日词汇目标",
    daily_vocab_title: "每日词汇 📖",
    daily_vocab_desc: "今天学习5个新单词，持续练习直至取得满分！",
    keep_practicing_vocab_title: "继续练习 📚",
    keep_practicing_vocab_desc: "随机复习5个单词，然后体验趣味小游戏！",

    // Grammar Module
    daily_grammar_goal: "每日语法目标",
    daily_grammar_title: "每日语法 📜",
    daily_grammar_desc: "今天学习一个新的语法概念并完成测验！",
    keep_learning_grammar_title: "继续学习 📚",
    keep_learning_grammar_desc: "浏览语法概念完整列表，选择你想学习的内容。",

    // Writing Module
    writing_practice_title: "写作练习",
    daily_writing_goal: "每日写作目标",
    daily_mission_title: "今日写作任务",
    daily_mission_desc: "完成今日写作题目以获得星星！",
    keep_practicing_title: "继续练习 📚",
    keep_practicing_desc: "浏览当前年级段的完整写作题目列表，随心练习与提高。",
    start_writing_btn: "开始写作 🚀",
    keep_practicing_btn: "继续练习 🚀",

    voice_battle_title: "语音对决 ⚔️",
    choose_hero: "选择你的英雄：",
    choose_pet: "选择你的宠物：",
    select_monster: "选择要挑战的怪物！",
    click_mic_attack: "点击麦克风并大声念出目标单词发起攻击！",

    courtroom_select_level: "选择关卡",
    courtroom_examine_statement: "仔细审查证人证词，判断是否有语法错误！",
    courtroom_statement_correct: "证词正确 表达无误",
    courtroom_statement_flawed: "存在语法错误",

    shop_title: "道具商店 🛒",
    shop_subtitle: "升级你的语音对决英雄与语法法庭装备！",
    tab_voice_battle: "⚔️ 语音对决",
    tab_grammar_court: "⚖️ 语法法庭",

    shop_bronze_shield_name: "青铜守护盾 🛡️",
    shop_bronze_shield_desc: "在语法法庭中保护1颗心免受错误扣分！",
    shop_silver_shield_name: "白银卫士盾 🛡️",
    shop_silver_shield_desc: "在语法法庭中保护2颗心免受错误扣分！",
    shop_gold_shield_name: "黄金裁决盾 🛡️",
    shop_gold_shield_desc: "在语法法庭中保护全部3颗心免受错误扣分！",
    shop_gavel_name: "黄金法锤 (双倍星星) ⭐⭐",
    shop_gavel_desc: "每次赢得法庭审判即可获得双倍(2x)星星奖励！",
    
    shop_hourglass_name: "魔法沙漏 ⏳",
    shop_hourglass_desc: "将语音对决朗读时间延长至90秒！",
    shop_knight_name: "圣骑士职业 ⚔️",
    shop_knight_desc: "在语音对决中每回合造成30点攻击伤害！",
    shop_paladin_name: "光辉游侠职业 ✨",
    shop_paladin_desc: "在语音对决中每回合造成50点超强攻击伤害！",
    shop_golem_name: "水晶傀儡 🗿",
    shop_golem_desc: "穿透敌人护盾直接造成伤害！",
    shop_dragon_name: "烈焰小龙 🐉",
    shop_dragon_desc: "发射火球造成10点额外伤害！",
    shop_griffin_name: "风暴狮鹫 🦅",
    shop_griffin_desc: "使你的总攻击伤害翻5倍！",

    shop_equip_hero: "装备英雄",
    shop_equip_pet: "装备宠物",
    shop_equip_shield: "装备护盾",
    shop_hero_equipped: "已装备英雄",
    shop_pet_equipped: "已装备宠物",
    shop_shield_equipped: "已装备护盾",
    shop_owned_active: "已拥有并生效",
    shop_purchase_btn: "购买",
    shop_need_stars: "还需要"
  }
};
